/* eslint-disable @typescript-eslint/no-explicit-any */
import EventAgent from '@hotmart-org-ca/event-agent-js'

import { DataHubEntities } from './dataHubEntities'

type SendEventParams<Schema = any> = {
  schema: Schema
  entity?: DataHubEntities
  dataVersion?: string
}

EventAgent.mode = location.hostname.endsWith('buildstaging.com') ? 'staging' : 'production'

class DataHubService {
  static sendEvent({
    schema,
    dataVersion = '1.0',
    entity = DataHubEntities.Home
  }: SendEventParams) {
    const dataHubEvent = {
      system: 'hotmart_club',
      entity,
      action: schema.action,
      data_version: dataVersion,
      event: schema.getDataHubEventData() as object
    }

    if (process.env.NODE_ENV === 'development') {
      // eslint-disable-next-line no-console
      console.log('Datahub event dispatched: ', dataHubEvent)
    }

    EventAgent.send(dataHubEvent)
  }
}

export default DataHubService
